import { z } from 'zod';
import { skillCategorySchema } from './common.js';
import {
  strapiCertificationBaseSchema,
  strapiEducationBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiCertificationSchema = strapiCertificationBaseSchema.extend({
  categories: z.array(skillCategorySchema),
  skills: z.array(strapiSkillBaseSchema).nullish(),
  education: z.array(strapiEducationBaseSchema).nullish(),
});

export type StrapiCertificationResponse = z.infer<
  typeof strapiCertificationSchema
>;
